import { type BaseUser } from 'Users';
import { type ProgramFamily } from 'Program';

export const getProgramFamilyApplication = (user: BaseUser | null, programFamily: ProgramFamily) =>
    user?.programFamilyApplications.find(
        programFamilyApplication => programFamilyApplication.programFamily === programFamily,
    );
